

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getMonthlyStats } from '../../../services/MonthlyStatsService';
import SalesOverviewCard from "./components/SalesOverviewCard";
import OrderStatisticsCard from "./components/OrderStatisticsCard";
import TopSellingCategoriesCard from "./components/TopSellingCategoriesCard";
import { getPropertyMonthlyTypeStats } from '../../../services/DashboardService';
import { getSubscriptionMonthlyAmount } from '../../../services/SubscriptionService';
import LatestTransactionsCard from "./components/LatestTransactionsCard";
import RecentActivityCard from "./components/RecentActivityCard";
import SalesStatisticsCard from "./components/SalesStatisticsCard";
import OverallStatisticsCard from "./components/OverallStatisticsCard";
import { getLatestTransactions } from '../../../services/LatestTransactionsService';
import Overview from "./components/Overview";
import IndiaMap from "./components/IndiaMap";
import Spkcardscomponent from "./components/spk-cards";
import { getPropertySummaryAction } from "../../../store/actions/Report/ReportActions";

import { getLatestProperties } from '../../../services/LatestPropertiesService';
import { getWeeklyListingTypeCounts } from '../../../services/WeeklyListingTypeCountsService';
import { getDailyStatsCurrentMonth } from '../../../services/DailyStatsService';
import { set } from "date-fns";


function Home() {
  const [subscriptionStats, setSubscriptionStats] = useState({ totalSubscriptions: 0, totalAmount: 0, listingTypeNames: '', subscriptionCounts: '' });
  const [sellingData, setSellingData] = useState([]);
  const [latestTransactions, setLatestTransactions] = useState([]);
  const [monthlyStats, setMonthlyStats] = useState({ months: [], stats: [] });
  const [totalSellingData, setTotalSellingData] = useState(0);
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.auth);
  const [userPolicies, setUserPolicies] = useState([]);
  const { propertySummary } = useSelector((state) => state.report);
  const total = propertySummary?.totalProperties || 0;
  const sold = propertySummary?.propertiesSold || 0;
  const sale = propertySummary?.propertiesForSale || 0;
  const rent = propertySummary?.propertiesForRent || 0;
  const lease = propertySummary?.propertiesForLease || 0;
  const featured = propertySummary?.featuredProperties || 0;
  const users = propertySummary?.totalUsers || 0;
  const payment = propertySummary?.totalSubscriptionAmount * 0.01 || 0;
  const [latestProperties, setLatestProperties] = useState([]);
  const [dailyStats, setDailyStats] = useState([]);
  const [dailyStatsPercentage, setDailyStatsPercentage] = useState([]);
  const [weeklyListingTypeCounts, setWeeklyListingTypeCounts] = useState({ days: [], stats: [], totals: {} });




  useEffect(() => {
    getDailyStatsCurrentMonth()
      .then(res => {
        if (res && res.success && res.data && res.data.data) {
          setDailyStats(res.data.data);
          setDailyStatsPercentage(res.data.stats || []);
          console.log("daily stats", res.data.data);
        }
      })
      .catch(() => setDailyStats([]));
  }, []);


  useEffect(() => {
    getWeeklyListingTypeCounts()
      .then(res => {
        if (res && res.success && res.data && res.data.data) {
          setWeeklyListingTypeCounts(res.data.data);
        }
      })
      .catch(() => setWeeklyListingTypeCounts({ days: [], stats: [], totals: {} }));
  }, []);

  useEffect(() => {
    getLatestProperties()
      .then(res => {
        if (res && res.success && res.data && res.data.data) {
          console.log("latest properties", res.data.data);
          setLatestProperties(res.data.data);
        }
      })
      .catch(() => setLatestProperties([]));
  }, []);

  useEffect(() => {
    getLatestTransactions()
      .then(res => {
        if (res && res.success && res.data && res.data.data) {
          setLatestTransactions(res.data.data);
        }
      })
      .catch(() => setLatestTransactions([]));
  }, []);

  useEffect(() => {
    getMonthlyStats()
      .then(res => {
        if (res && res.success && res.data) {
          console.log('monthlyStats', res.data);
          setMonthlyStats(res.data.data);
        }
      })
      .catch(() => setMonthlyStats({ months: [], stats: [] }));
  }, []);

  useEffect(() => {
    setUserPolicies(auth?.userPolicy?.policy)
  }, [auth]);

  useEffect(() => {
    // Fetch top selling categories data
    getPropertyMonthlyTypeStats()
      .then(res => {
        if (res && res.success && res.data && res.data.data && res.data.data.stats) {
          setSellingData(res.data.data.stats);
          setTotalSellingData(res.data.data.total || 0);
        } else {
          setSellingData([]);
        }
      })
      .catch(() => setSellingData([]));
  }, []);

  useEffect(() => {
    getSubscriptionMonthlyAmount()
      .then(res => {
        console.log('subscription stats', res);
        if (res && res.success && res.data && res.data.data) {
          setSubscriptionStats(res.data.data);
        }
      })
      .catch(() => setSubscriptionStats({ totalSubscriptions: 0, totalAmount: 0, listingTypeNames: '', subscriptionCounts: '' }));
  }, []);

  useEffect(() => {
    dispatch(getPropertySummaryAction());
  }, [dispatch]);

  const Cardsdata = [
    {
      id: 1,
      title: "Total Properties",
      count: total,
      inc: "Increased By ",
      percentageChange: "2.56%",
      iconClass: "bi bi-building-fill",
      icon: "bi bi-arrow-up-short",
      backgroundColor: "primary",
      color: "success",
    },
    {
      id: 2,
      title: "Total Users",
      count: users,
      inc: "Increased By ",
      percentageChange: "0.34%",
      iconClass: "bi bi-people-fill",
      icon: "bi bi-arrow-up-short",
      backgroundColor: "primary1",
      color: "success",
    },
    {
      id: 3,
      title: "Total Payments",
      count: "₹" + payment,
      inc: "Increased By ",
      percentageChange: "7.66%",
      iconClass: "bi bi-currency-dollar",
      icon: "bi bi-arrow-up-short",
      backgroundColor: "primary2",
      color: "success",
    },
    {
      id: 4,
      title: "Active Subscriptions",
      count: featured,
      inc: "Decreased By ",
      percentageChange: "0.74%",
      iconClass: "bi bi-bar-chart-fill",
      icon: "bi bi-arrow-down-short",
      backgroundColor: "primary3",
      color: "danger",
    },
  ];
  console.log('monthlyStats1', monthlyStats);
  const Overseries = monthlyStats.stats;
  const Overoptions = {
    chart: {
      redrawOnWindowResize: true,
      height: 315,
      type: "bar",
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 7,
        left: 0,
        blur: 1,
        color: ["transparent", "transparent", "rgb(227, 84, 212)"],
        opacity: 0.05,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "18%",
        borderRadius: 2,
      },
    },
    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 3,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [0, 2, 2],
      curve: "smooth",
    },
    legend: {
      show: true,
      fontSize: "12px",
      position: "bottom",
      horizontalAlign: "center",
      fontWeight: 500,
      height: 40,
      offsetX: 0,
      offsetY: 10,
      labels: {
        colors: "#9ba5b7",
      },
      markers: {
        width: 7,
        height: 7,
        shape: "circle",
        size: 3.5,
        strokeWidth: 0,
        strokeColor: "#fff",
        fillColors: undefined,
        radius: 12,
        offsetX: 0,
        offsetY: 0,
      },
    },
    colors: [
      "rgba(92, 103, 247, 0.85)",
      "rgba(119, 119, 142, 0.05)",
      "rgba(227, 84, 212, 0.85)",
    ],
    yaxis: {
      title: {
        style: {
          color: "#adb5be",
          fontSize: "14px",
          fontFamily: "poppins, sans-serif",
          fontWeight: 600,
          cssClass: "apexcharts-yaxis-label",
        },
      },
      labels: {
        formatter: function (y) {
          return y.toFixed(0) + "";
        },
        show: true,
        style: {
          colors: "#8c9097",
          fontSize: "11px",
          fontWeight: 600,
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
    xaxis: {
      type: "category",
      categories: monthlyStats.months,
      axisBorder: {
        show: true,
        color: "rgba(119, 119, 142, 0.05)",
        offsetX: 0,
        offsetY: 0,
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "rgba(119, 119, 142, 0.05)",
        width: 6,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        rotate: -90,
        style: {
          colors: "#8c9097",
          fontSize: "11px",
          fontWeight: 600,
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0) + "%";
          }
          return y;
        },
      },
    },
    fill: {
      colors: undefined,
      opacity: 0.025,
      type: ["solid", "solid"],
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#fdc530"],
        inverseColors: true,
        opacityFrom: 0.35,
        opacityTo: 0.05,
        stops: [0, 50, 100],
        colorStops: ["#fdc530"],
      },
    },
  };
  const Staticseries = [
    ...(subscriptionStats.subscriptionCounts
      ? subscriptionStats.subscriptionCounts.split(',').map(Number)
      : [])
  ];
  const Staticoptions = {
    chart: {
      height: 210,
      type: "donut",
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      height: 52,
      markers: {
        width: 8,
        height: 8,
        radius: 2,
        shape: "circle",
        size: 4,
        strokeWidth: 0,
      },
      // offsetY: 24,
    },
    stroke: {
      show: true,
      curve: "smooth",
      lineCap: "round",
      // colors: "#fff",
      width: 0,
      dashArray: 0,
    },
    labels: [
      ...(subscriptionStats.listingTypeNames
        ? subscriptionStats.listingTypeNames.split(',').map(String)
        : [])
    ],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        offsetY: 10,
        expandOnClick: false,
        donut: {
          size: "80%",
          background: "transparent",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "20px",
              color: "#495057",
              offsetY: -25,
            },
            value: {
              show: true,
              fontSize: "15px",
              color: undefined,
              offsetY: -20,
              formatter: function (val) {
                return val + "%";
              },
            },
            total: {
              show: true,
              showAlways: true,
              label: "Total",
              fontSize: "22px",
              fontWeight: 600,
              color: "#495057",
            },
          },
        },
      },
    },
    grid: {
      padding: {
        bottom: -100,
      },
    },
    colors: [
      "rgba(92, 103, 247, 0.85)",
      "rgba(227, 84, 212, 1)",
      "rgba(255, 93, 159, 1)",
      "rgba(255, 142, 111, 1)",
    ],
  };


  const Saleseries = weeklyListingTypeCounts.stats;
  const Saleoptions = {
    chart: {
      height: 265,
      type: "line",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 3,
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      markers: {
        size: 4,
        shape: "circle",
        strokeWidth: 0,
      },
    },
    stroke: {
      curve: "smooth",
      width: [0],
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        borderRadius: 3,
        borderRadiusWhenStacked: "all",
      },
    },
    colors: [
      "rgba(92, 103, 247, 1)",
      "rgba(227, 84, 212, 1)",
      "rgba(255, 142, 111, 1)",
    ],
    labels: weeklyListingTypeCounts.days && weeklyListingTypeCounts.days.length > 0 ? weeklyListingTypeCounts.days : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  };

  // Use API data for Graphseries if available, fallback to default
  const Graphseries = dailyStats && dailyStats.length > 0 ? dailyStats : [
    {
      name: "Total Income",
      data: [0, 30, 10, 35, 26, 31, 14, 22, 40, 12],
    },
  ];

  const Graphoptions = {
    chart: {
      type: "line",
      height: 30,
      width: 100,
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: false,
        blur: 3,
        opacity: 0.2,
      },
    },
    stroke: {
      show: true,
      curve: "smooth",
      lineCap: "butt",
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    fill: {
      gradient: {
        // enabled: false
      },
    },
    // min: 0
  };

  const Graph2series = [
    {
      name: "Total Income",
      data: [0, 20, 15, 25, 15, 25, 6, 25, 32, 15],
    },
  ];
  const Graph2options = {
    chart: {
      type: "line",
      height: 30,
      width: 100,
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: false,
        blur: 3,
        opacity: 0.2,
      },
    },
    stroke: {
      show: true,
      curve: "smooth",
      lineCap: "butt",
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    fill: {
      gradient: {
        // enabled: false
      },
    },
    // yaxis: {
    //   // min: 0
    // },
    colors: ["rgb(227, 84, 212)"],
  };

  //line-graph3
  const Graph3series = [
    {
      name: "Total Income",
      data: [0, 10, 30, 12, 16, 25, 4, 35, 26, 15],
    },
  ];
  const Graph3options = {
    chart: {
      type: "line",
      height: 30,
      width: 100,
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: false,
        blur: 3,
        opacity: 0.2,
      },
    },
    stroke: {
      show: true,
      curve: "smooth",
      lineCap: "butt",
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    fill: {
      gradient: {
        // enabled: false
      },
    },
    colors: ["rgb(255, 93, 159)"],
  };

  //line-graph4
  const Graph4series = [
    {
      name: "Total Income",
      data: [0, 12, 19, 26, 10, 18, 8, 17, 35, 14],
    },
  ];
  const Graph4options = {
    chart: {
      type: "line",
      height: 30,
      width: 100,
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: false,
        blur: 3,
        opacity: 0.2,
      },
    },
    stroke: {
      show: true,
      curve: "smooth",
      lineCap: "butt",
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    fill: {
      gradient: {
        // enabled: false
      },
    },
    colors: ["rgb(255, 142, 111)"],
  };

  //line-graph5
  const Graph5series = [
    {
      name: "Total Income",
      data: [0, 12, 19, 17, 35, 14, 26, 10, 18, 8],
    },
  ];
  const Graph5options = {
    chart: {
      type: "line",
      height: 30,
      width: 100,
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: false,
        blur: 3,
        opacity: 0.2,
      },
    },
    stroke: {
      show: true,
      curve: "smooth",
      lineCap: "butt",
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    fill: {
      gradient: {
        // enabled: false
      },
    },
    colors: ["rgb(158, 92, 247)"],
  };


  return (
    <>
      <div className="form-head d-md-flex mb-sm-4 mb-3 align-items-start">
        <div className="me-auto  d-lg-block">
          <h2 className="text-black font-w600">Dashboard</h2>
          <p className="mb-0">Welcome to HotplotZ Admin</p>
        </div>
      </div>
      {userPolicies.includes('POL0011') && (
        <div className="row">
          {/* <PropertyOverView/> */}
          <div className="col-8">
            <div className="row">
              {Cardsdata.map((idx) => (
                <div key={idx.id} className="col-3">
                  <Spkcardscomponent
                    textbefore={false}
                    textafter={true}
                    cardClass="overflow-hidden main-content-card"
                    headingClass="d-block mb-1"
                    mainClass="d-flex align-items-start justify-content-between mb-2"
                    Icon={true}
                    iconClass={idx.iconClass}
                    card={idx}
                    badgeClass="md rounded-pill"
                    dataClass="mb-0"
                  />
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-xxl-8 col-xl-8">
                <SalesOverviewCard Overoptions={Overoptions} Overseries={Overseries} />
              </div>
              <div className="col-xxl-4 col-xl-4">
                <OrderStatisticsCard Staticoptions={Staticoptions} Staticseries={Staticseries} TotalSubscription={subscriptionStats.totalAmount} />
              </div>
            </div>
          </div>
          <div className="col-4">
            <TopSellingCategoriesCard data={sellingData} total={totalSellingData} />
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-xxl-6 col-xl-3">
                <LatestTransactionsCard LatestTransactions={latestTransactions} />
              </div>
              <div className="col-xxl-6 col-xl-3">
                <RecentActivityCard LatestProperties={latestProperties} />
              </div>
              <div className="col-xxl-6 col-xl-3">
                <SalesStatisticsCard Saleoptions={Saleoptions} Saleseries={Saleseries} Totals={weeklyListingTypeCounts.totals} />
              </div>
              <div className="col-xxl-6 col-xl-3">
                <OverallStatisticsCard
                  Graphoptions={Graphoptions} DailyStats={dailyStats} DailyStatsPercentage={dailyStatsPercentage}
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <Overview />
          </div>
          <div className="col-12">
            <IndiaMap />
          </div>
          {/* <RevenueChart /> */}
          {/* <AdsBarChart /> */}

        </div>

      )}
      {userPolicies.includes('POL0012') && (
        <div className="row">
          <div className="col-12">
            <div className="card p-5 text-center">
              <h2>Bank Agent Dashboard</h2>
              <p>This is a placeholder for bank agent dashboard content.</p>
            </div>
          </div>
        </div>
      )}
      {userPolicies.includes('POL0013') && (
        <div className="row">
          <div className="col-12">
            <div className="card p-5 text-center">
              <h2>Property verification agent Dashboard</h2>
              <p>This is a placeholder for property verification agent dashboard content.</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;
